import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../../components/shared/Sidebar";
import Topbar from "../../../components/shared/Topbar";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/admin", end: true, icon: "📊" },
  { label: "Doctors", path: "/admin/doctors", icon: "👨‍⚕️" },
  { label: "Labs", path: "/admin/labs", icon: "🧪" },
  { label: "Patients", path: "/admin/patients", icon: "🧑‍🤝‍🧑" },
  { label: "Reports", path: "/admin/reports", icon: "📈" },
  { label: "Broadcast", path: "/admin/broadcast", icon: "📢" },
  { label: "Payments", path: "/admin/payments", icon: "💳" },
  { label: "Test Categories", path: "/admin/test-categories", icon: "🔬" },
  { label: "Advertisements", path: "/admin/advertisements", icon: "📣" },
  { label: "Clinics", path: "/admin/clinics", icon: "🏥" },
];

const PAGE_TITLES = {
  "/admin": "Dashboard",
  "/admin/doctors": "Doctor Management",
  "/admin/labs": "Lab Management",
  "/admin/patients": "Patient Management",
  "/admin/reports": "Reports",
  "/admin/broadcast": "Broadcast Messages",
  "/admin/payments": "Payment Management",
  "/admin/test-categories": "Test Categories",
  "/admin/advertisements": "Advertisements",
  "/admin/clinics": "Clinics",
};

export default function AdminLayout() {
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar
        logo="🏥"
        title="Admin Panel"
        navItems={NAV_ITEMS}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar title={PAGE_TITLES[pathname] || "Admin"} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
